import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TableConfig } from "@app/shared/util/table-config.utils";

import { ToolRequest } from '@models/toolRequests.model';

@Component({
    selector: 'app-pending-tool-requests-table',
    templateUrl: './pending-tool-requests-table.component.html',
    styleUrls: ['./pending-tool-requests-table.component.scss']
})
export class PendingToolRequestsTableComponent {

    @Input() pendingToolRequests: ToolRequest[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() statusFilters = [];
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = false;
    @Input() isMaterial = false;
    @Input() showFilters = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();


    onPageChange(tableConfig: TableConfig) {
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this.filterChange.emit(tableConfig);
    }

    onRowClick(clickedItem) {
        this.rowClick.emit(clickedItem);
    }
}
